import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { LoginModel } from './loginModel';
import  jwt_decode  from 'jwt-decode';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AuthenticationService } from "../firebase/authentication.service";
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { FunctionsService } from "../services/functions.service";
import { NgxPermissionsService } from 'ngx-permissions';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import { VerifyEmailComponent } from '../register/verify-email/verify-email.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from '../app.constants';
import { NgxSpinnerService } from "ngx-spinner";
import { SignalRService } from '../services/signalr.service';
import { ChangeTempPasswordComponent } from './change-temp-password/change-temp-password.component';
import { AuthService } from '../guards/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [NgxSpinnerService]
})

export class LoginComponent implements OnInit {
    err: string = "";
    emailErr: string = "";
    passErr: string = "";
    userState: any;
    fireEmail: string;
    firePassword: string;
    translateFunc: any;
    modalOptions: NgbModalOptions = {};
    lang = "EN";
    url="";
    currentYear = new Date().getFullYear();


    loginForm = new UntypedFormGroup({
        Email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern(AppConstants.emailRegex)
        ])),
        Password: new UntypedFormControl('')
    });

    constructor(
        private apiService: ApiService,
        private login: LoginModel,
        private router: Router,
        public afAuth: AngularFireAuth,
        public authenticationService: AuthenticationService,
        public functionsService:FunctionsService,
        private permission: NgxPermissionsService,
        private translate: TranslateService,
        private modalService: NgbModal,
        private spinner: NgxSpinnerService,
        private signalRservice: SignalRService,
        private authService: AuthService,
        private activatedRoute: ActivatedRoute
    ) { 
        this.url = this.activatedRoute.queryParams["_value"]["url"];
        translate.setDefaultLang('en');
        this.translateFunc = functionsService;
        this.functionsService.setTitle('general.login');
    }

    async ngOnInit() {
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.lang = event["lang"];
        });
        if(this.signalRservice.connection){
            this.signalRservice.connection.stop();
        }
        if(localStorage.getItem('language') != null){
            this.translateFunc.useLanguage(localStorage.getItem('language'));
        }else{
            this.translateFunc.useLanguage('en');
        }
        //If token exists and is valid, then go to portal. If not, show the login screen
        if (localStorage.getItem('role') != null) {
            var currentRole = localStorage.getItem('role');
            if (currentRole != undefined) {
                //Access control
                //Verify if users exists and is active
                (await this.apiService.verifyUser()).subscribe(
                    data => {
                        if(data) {
                            this.authService.login();
                            if(currentRole=="Activate" && localStorage.getItem('active')=='2'){
                                var email = localStorage.getItem("email");
                                this.validOwner(email);
                            }
                            else if(localStorage.getItem('active')=='2' || localStorage.getItem('active')=='3'){ //The user needs to change his password                                this.spinner.hide();
                                var language = localStorage.getItem("language");
                                localStorage.clear();
                                localStorage.setItem('language', language);
                            }
                            else{
                                this.router.navigateByUrl('/main');
                            }
                        } else {
                            this.err = this.translate.instant('general.invalid_account');
                            this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
                                this.err = this.translate.instant('general.invalid_account');
                            })
                        }
                    },
                    error => {
                        this.err = this.translate.instant('general.something_wrong');
                        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
                            this.err = this.translate.instant('general.something_wrong');
                        })
                    }
                )
            }
        }
    }
    formSubmitted: boolean = false;

    async loginUser(event) {
        //Do not perform an action if email is invalid
        if (!this.loginForm.valid) {
            this.formSubmitted = true;
            return;
        } 
        event.preventDefault();
        this.err = "";
        this.emailErr = "";
        this.passErr = "";
        this.login.Email = event.target.querySelector('#Email').value;
        this.login.Password = event.target.querySelector('#Password').value;
        this.spinner.show();
        try {
            //const data = await this.apiService.login(this.login).toPromise();
            await this.apiService.login(this.login).subscribe(
                async resp => {                    
                    //Firebase credentials
                    this.authenticationService.SignIn();
                    localStorage.setItem('Expired', resp['expired']);
                    localStorage.setItem('userId', resp['userId']);
                    localStorage.setItem('orgId', resp['orgId']);
                    localStorage.setItem('role', resp['role']);
                    localStorage.setItem('email', resp['email']);
                    localStorage.setItem('active', resp['active']);
                    var currentRole = resp['role'];
                    this.authService.login();
                    this.permission.addPermission([currentRole]);
                    if(currentRole=="Activate" && resp["active"]==2){
                        var email = resp['email'];
                        this.validOwner(email);
                    }
                    else if(resp["active"]==2 || resp["active"]==3){ //The user needs to change his password
                        this.changePasswordModal();
                    }else{
                        this.spinner.hide();
                        localStorage.setItem('fullName',resp['name']);
                        if(this.url!=""){
                            this.router.navigateByUrl(this.url);
                        }
                        else{
                            this.router.navigateByUrl('/main');
                        }
                    }
                },
                error => {
                    this.spinner.hide();
                    if(error["status"]==0){
                        this.err = this.translate.instant('general.something_wrong');
                        this.translate.onLangChange.subscribe(() => {
                            this.err = this.translate.instant('general.something_wrong');
                        })
                    }else if(error["error"]&&error["error"]["content"]){
                        this.addError(error["error"]["content"]);
                        this.err = this.translate.instant(error["error"]["content"]);
                        this.translate.onLangChange.subscribe(() => {
                            this.err = this.translate.instant(error["error"]["content"]);
                        })
                    }
                }
            );
        }
        catch (error) {
            //Three possible errors
            if (!(error["error"]["content"])===undefined) {
                this.err = error["error"]["content"];
            }
            //These two are very unlikely to happen (each field has the required clause enabled)
            if (!(error["error"]["Email"])===undefined) {
                this.emailErr = error["error"]["Email"]['0'];
            }
            if (!(error["error"]["Password"])===undefined) {
                this.passErr = error["error"]["Password"]['0'];
            }
        }
    }

    validOwner(email){
        //User did not enter the verification code
        var language = localStorage.getItem("language")?localStorage.getItem("language").toUpperCase():"EN";
        (<HTMLButtonElement>document.getElementById("login")).disabled = true;
        localStorage.clear();
        localStorage.setItem('language', language);
        this.apiService.resendCode({"Email":email, "Language":language}).subscribe(
            () => {
                (<HTMLButtonElement>document.getElementById("login")).disabled = false;
                //Show verify account modal
                this.modalOptions.backdrop = 'static';
                this.modalOptions.keyboard = false;
                const modalRef = this.modalService.open(VerifyEmailComponent, this.modalOptions);
                modalRef.componentInstance.email = email;
                modalRef.componentInstance.userLang = this.lang.toUpperCase();
                this.spinner.hide();
            },
            error => {
                (<HTMLButtonElement>document.getElementById("login")).disabled = false;
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        )
    }

    changePasswordModal(){
        this.spinner.hide();
        this.modalOptions.backdrop = 'static';
        this.modalOptions.keyboard = false;
        this.modalOptions.size = 'lg';
        const modalRef = this.modalService.open(ChangeTempPasswordComponent, this.modalOptions);
        modalRef.componentInstance.userToUpdate = this.login.Password;
        modalRef.result.then();
    }
    addError(errorMessage){
        if(errorMessage!="invalid_credentials"){
            document.getElementById("Email").classList.add('is-invalid');
            document.getElementById("Email").addEventListener("click", this.removeErrorE, {passive: true});
        }
        document.getElementById("Password").classList.add('is-invalid');
        document.getElementById("Password").addEventListener("click", this.removeError, {passive: true});
    }
    removeError(){
        document.getElementById("Password").classList.remove('is-invalid');
        document.getElementById("err").innerHTML = "";
    }
    removeErrorE(){
        document.getElementById("Email").classList.remove('is-invalid');
        document.getElementById("err").innerHTML = "";
    }

    get Email() { return this.controlGetter('Email'); }
    get Password() { return this.controlGetter('Password'); }

    controlGetter(controlName) {
        const control = this.loginForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }
}